import { FC, useCallback, useEffect } from 'react';
import { $fm } from '@/Intl';
import { Button, Upload } from 'antd';
import { DeleteOutlined } from '@ant-design/icons';
import { observer } from 'mobx-react';
import { useCustomLang } from '@/store';
import './CustomLang.less';

const CustomLang: FC<CustomFieldsProps> = (props) => {
  const { onChange, value } = props;
  const [customLang, setCustomLang] = useCustomLang();

  const beforeUpload = useCallback(
    (file: File) => {
      setCustomLang(file);

      return false;
    },
    [setCustomLang],
  );

  const handleDelete = useCallback(() => {
    setCustomLang(null);
  }, [setCustomLang]);

  useEffect(() => {
    if (customLang) {
      onChange && onChange(customLang.name, customLang);
    } else {
      onChange && onChange('', null);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [customLang]);

  return (
    <div className='cus-lang-upload'>
      <Upload beforeUpload={beforeUpload} showUploadList={false}>
        <Button type='primary'> {$fm('UPLOAD')} </Button>
      </Upload>
      {value ? (
        <>
          <span className='lang-file'>{value}</span>
          <DeleteOutlined onClick={handleDelete} />
        </>
      ) : null}
    </div>
  );
};

export default observer(CustomLang);
